// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .ui-panel .ui-panel-content 
{
    border-top: 1px solid #c8c8c8 !important;
}

:host ::ng-deep .p-datatable .p-datatable-tbody > tr.ui-state-highlight {
    background-color: #007ad9 !important;
    color: #fff !important;
}

:host ::ng-deep .p-datatable .p-datatable-tbody>tr>td {
    /* border: none; */
    border-bottom: 1px solid #c8c8c8 !important;
    padding : 0.571rem 0.857rem;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    max-width: 400px !important;
    max-height: 150px !important;
    overflow: hidden !important;
}
:host ::ng-deep .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
    color: #ffffff !important;
}

:host ::ng-deep .p-paginator .p-paginator-pages .p-paginator-page {
    color : #848484 !important;
}
:host ::ng-deep .p-paginator-element {
    color : #333333 !important;
}
:host ::ng-deep .p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler {
    color : #665f5f !important;
}

:host ::ng-deep .p-link {
    font-size: 1rem !important;
}

:host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
    text-align: left;
    padding: 0.571rem 0.857rem;
    border: 1px solid #c8c8c8;
    border-width: 1px 1px 1px 1px;
    font-weight: 700;
    color: #333333;
    background: #f4f4f4;
    transition: background-color 0.2s, box-shadow 0.2s;
}
.disable{
    cursor: not-allowed;
    pointer-events: none;
    }

:host ::ng-deep .p-tree-container {
    margin: 0 !important;
}  
:host ::ng-deep .p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler:focus {
    outline: 0 none;
    outline-offset: 0;
    box-shadow: 0 0 0 0.2rem #8dcdff;
}
:host ::ng-deep .p-toast .p-toast-message {
    border-radius: 3px;
}

:host ::ng-deep .p-toast .p-toast-message-content {
    padding: 0px !important;
}

:host ::ng-deep .p-toast .p-toast-close-icon {
    color: #ffffff !important;
    /* margin-top: 10px; */
}

.toast-header{
    background-color: #165788;
    color: #FFF;
    padding: 1px 1px 1px 10px !important;    
}

.validatinClass{
    border-color: red !important;
}

.asset-search-input {
    width: 74%; 
    float: left; 
    height: 30px !important; 
    border-radius: 3px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/asset-tree/asset-tree.component.css"],"names":[],"mappings":"AAAA;;IAEI,wCAAwC;AAC5C;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,2CAA2C;IAC3C,2BAA2B;IAC3B,kCAAkC;IAClC,8BAA8B;IAC9B,2BAA2B;IAC3B,4BAA4B;IAC5B,2BAA2B;AAC/B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,yBAAyB;IACzB,6BAA6B;IAC7B,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,kDAAkD;AACtD;AACA;IACI,mBAAmB;IACnB,oBAAoB;IACpB;;AAEJ;IACI,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,gCAAgC;AACpC;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,oCAAoC;AACxC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,6BAA6B;AACjC","sourcesContent":[":host ::ng-deep .ui-panel .ui-panel-content \r\n{\r\n    border-top: 1px solid #c8c8c8 !important;\r\n}\r\n\r\n:host ::ng-deep .p-datatable .p-datatable-tbody > tr.ui-state-highlight {\r\n    background-color: #007ad9 !important;\r\n    color: #fff !important;\r\n}\r\n\r\n:host ::ng-deep .p-datatable .p-datatable-tbody>tr>td {\r\n    /* border: none; */\r\n    border-bottom: 1px solid #c8c8c8 !important;\r\n    padding : 0.571rem 0.857rem;\r\n    text-overflow: ellipsis !important;\r\n    white-space: nowrap !important;\r\n    max-width: 400px !important;\r\n    max-height: 150px !important;\r\n    overflow: hidden !important;\r\n}\r\n:host ::ng-deep .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {\r\n    color: #ffffff !important;\r\n}\r\n\r\n:host ::ng-deep .p-paginator .p-paginator-pages .p-paginator-page {\r\n    color : #848484 !important;\r\n}\r\n:host ::ng-deep .p-paginator-element {\r\n    color : #333333 !important;\r\n}\r\n:host ::ng-deep .p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler {\r\n    color : #665f5f !important;\r\n}\r\n\r\n:host ::ng-deep .p-link {\r\n    font-size: 1rem !important;\r\n}\r\n\r\n:host ::ng-deep .p-datatable .p-datatable-thead > tr > th {\r\n    text-align: left;\r\n    padding: 0.571rem 0.857rem;\r\n    border: 1px solid #c8c8c8;\r\n    border-width: 1px 1px 1px 1px;\r\n    font-weight: 700;\r\n    color: #333333;\r\n    background: #f4f4f4;\r\n    transition: background-color 0.2s, box-shadow 0.2s;\r\n}\r\n.disable{\r\n    cursor: not-allowed;\r\n    pointer-events: none;\r\n    }\r\n\r\n:host ::ng-deep .p-tree-container {\r\n    margin: 0 !important;\r\n}  \r\n:host ::ng-deep .p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler:focus {\r\n    outline: 0 none;\r\n    outline-offset: 0;\r\n    box-shadow: 0 0 0 0.2rem #8dcdff;\r\n}\r\n:host ::ng-deep .p-toast .p-toast-message {\r\n    border-radius: 3px;\r\n}\r\n\r\n:host ::ng-deep .p-toast .p-toast-message-content {\r\n    padding: 0px !important;\r\n}\r\n\r\n:host ::ng-deep .p-toast .p-toast-close-icon {\r\n    color: #ffffff !important;\r\n    /* margin-top: 10px; */\r\n}\r\n\r\n.toast-header{\r\n    background-color: #165788;\r\n    color: #FFF;\r\n    padding: 1px 1px 1px 10px !important;    \r\n}\r\n\r\n.validatinClass{\r\n    border-color: red !important;\r\n}\r\n\r\n.asset-search-input {\r\n    width: 74%; \r\n    float: left; \r\n    height: 30px !important; \r\n    border-radius: 3px !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
